import { Progress, Typography } from 'antd';
import React from 'react';

const { Text } = Typography;

interface StepProgressProps {
  current: number;
  total: number;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

/**
 * Composant de progression circulaire affichant le format "current/total"
 * Basé sur le design Figma et l'API Ant Design Progress
 */
export const StepProgress: React.FC<StepProgressProps> = ({
  current,
  total,
  size = 32,
  strokeWidth = 12,
  className,
}) => {
  const percent = total > 0 ? (current / total) * 100 : 0;

  return (
    <div
      className={className}
      style={{ position: 'relative', width: size, height: size }}
    >
      <Progress
        type="circle"
        percent={percent}
        size={size}
        strokeWidth={strokeWidth}
        strokeColor="#20A76A"
        trailColor="#EDE9E6"
        format={() => (
          <Text
            style={{
              fontSize: 10,
              fontWeight: 600,
              color: '#3A3A3A',
              lineHeight: 1,
            }}
          >
            {current}/{total}
          </Text>
        )}
      />
    </div>
  );
};

export default StepProgress;
